import React from 'react';

function TimezoneDropdown({ timezones, onChange, value, label, name }) {
  return (
    <div className="w-[116px] max-w-sm sm:w-[150px]">
      {!label ? null : (
        <div
          htmlFor="timezone"
          className="block text-sm font-medium mb-2"
          style={{ color: 'var(--text-secondary)' }}
        >
          {label}
        </div>
      )}
      <select
        id="timezone"
        name={name}
        className="block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none sm:text-sm"
        style={{
          background: 'var(--input-bg)',
          borderColor: 'var(--input-border)',
          color: 'var(--input-text)'
        }}
        onChange={onChange}
        value={value}
      >
        {timezones.map((group) => (
          <optgroup key={group.label} label={group.label}>
            {group.options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </div>
  );
}

export default TimezoneDropdown;
